import { tryCatch } from '@thalesrc/js-utils';

import HSApi from '../HSApi';
import { GetWorkEquipmentTypeDefinitionResult } from './get-work-equipment-type-definition.result';

export async function getWorkEquipmentTypeDefinitions(): Promise<GetWorkEquipmentTypeDefinitionResult[]> {
  const [error, res] = await tryCatch(HSApi.get<GetWorkEquipmentTypeDefinitionResult[]>(`/work-equipment-type-definitions`));

  if (error) {
    // tslint:disable-next-line:no-console
    console.error(error);

    throw error;
  }

  return res.data;
}
